import { createSlice, createSelector } from '@reduxjs/toolkit'

const initialState = {
  data: {},
  loading: false,
  error: null,
}

const subscribe = createSlice({
  name: 'subscribe',
  initialState: initialState,
  reducers: {
    requestSubscribe(state) {
      state.loading = true
    },
    successSubscribe(state, { payload }) {
      state.data = payload;
      state.loading = false
      state.error = null
    },
    failureSubscribe(state, { payload }) {
      state.loading = false
      state.error = payload
    },
  },
})

export const subscribeToBlackFriday = params => async (dispatch, getState, { api }) => {
  try {
    dispatch(requestSubscribe())
    const resp = await api.subscriptionsSubscribe(params)
    const { result = 'success' } = resp

    if (result === 'success') {
      dispatch(successSubscribe(resp))
    } else {
      dispatch(failureSubscribe(resp))
    }
  } catch (err) {
    dispatch(failureSubscribe(err.toString()))
  }
}

export const getSubscribeState = createSelector(
  state => state.subscribe,
  subscribe => {
    const { loading, error, data } = subscribe;

    return {
      data,
      loading,
      error,
    }
  },
)

export const { requestSubscribe, successSubscribe, failureSubscribe } = subscribe.actions

export default subscribe.reducer
